import { Injectable } from '@angular/core';
import { SemovelProvider } from '../semovel/semovel';
import { Events } from 'ionic-angular';

@Injectable()
export class PromocaoUtilProvider {


  constructor(public server: SemovelProvider, private events:Events) {
  }


  verProduto(promocao){
    const request = { method: 'produto/find' };
    const body = {id:promocao.produto.id};

    this.server.postData(request, body).subscribe(data => {
      if (data){
        this.events.publish("produto:ver", data.dados);
      }else{
        this.server.showMessage("Não foi possível encontrar o produto selecionado. Tente novamente mais tarde.");          
      }

      return true;
    },
    error => {
      this.server.showError(error);          
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/promocao-util/promocao-util.ts